<template>
<div>我是夏天</div>
</template>

<script>
export default {
  name: "Summer"
}
</script>

<style scoped>
div{
  width: 100px;
  height: 100px;
  margin: 0 auto;
  background: red;
}
</style>